import { SmartTable } from "common/components/table/smartTable";
import { SmartTableModel } from "common/components/table/smartTableModel";

import { TabBodyView } from "./tabBody";

const ROW_HEIGHT = 25;
const TABLE_HEADER_HEIGHT = 27;

export const TableBody = TabBodyView.extend({
    className: "table-body",
    
    _getNumberOfRows() {
        const availableHeight = this.getOption("widget").getAvailableHeight(TABLE_HEADER_HEIGHT);
        return availableHeight / ROW_HEIGHT | 0;
    },
    
    getTableColumns() {
        const columnsGetter = this.getOption("widget").model.subtypeModel.get("doublePivot").columns;
        return columnsGetter({
            secondaryPivotString: this.getOption("secondaryPivotString"),
            secondaryPivotKey: this.getOption("key")
        });
    },
    
    makeContentBody() {
        const key = this.getOption("key");
        const widget = this.getOption("widget");
        
        return new SmartTable({
            collection: this.collection,
            model: new SmartTableModel({
                columns: this.getTableColumns(),
                pager: false,
                mode: "client",
                showLoadMore: false,
                limitRows: this._getNumberOfRows()
            }),
            onClickRow(row) {
                widget.drilldownToSecondPivot({
                    currentTarget: row.el
                }, row.model.get(key));
            }
        });
    }
});
